import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductSearchFlag } from '../../ProductSearchFlag'

export const ProductSearchResultItemSellerSponsoredLabel: FC = () => (
  <ProductSearchFlag className="border-dark-primary-min bg-light-primary-low">
    <FormattedMessage id="general.label.sponsored" />
  </ProductSearchFlag>
)
